import React from 'react';
import '../styles/components/professional_resume.css';
import { logo, logoBaites, logoSema, logoUfma, maximize_logo, dynamos_logo, infobaseItLogo, onebitLogo } from '../assets';
import { useLanguage } from '../contexts/LanguageContext';

interface ResumeData {
  id: string;
  title: string;
  company: string;
  description: string[];
  location: string;
  startDate: string;
  endDate: string;
  current: boolean;
  image: string;
}

const getImage = (imageName: string) => {
  switch (imageName) {
    case 'logoBaites.png':
      return logoBaites;
    case 'logoSema.jpg':
      return logoSema;
    case 'logo-ufma.png':
      return logoUfma;
    case 'maximize_logo.jpeg':
      return maximize_logo;
    case 'dynamos_logo.jpeg':
      return dynamos_logo;
    case 'infobase_it_logo.jpg':
      return infobaseItLogo;
    case 'onebit_logo.jpg':
      return onebitLogo;
    default:
      return logo;
  }
};

const ProfessionalResume: React.FC = () => {
  const { t } = useLanguage();
  const resumeData: ResumeData[] = t.resume.items;

  return (
    <div className="resume-container">
      <div className="header-container">
        <h1 className="section-title">{t.resume.title}</h1>
        <p className="section-description">{t.resume.description}</p>
      </div>
      <div className="resume-grid">
        {resumeData.map((data: ResumeData) => (
          <div key={data.id} className={`resume-card ${data.current ? 'current' : ''}`}>
            <img src={getImage(data.image)} alt={`Logo ${data.company}`} className="resume-image" />
            <div className="resume-info">
              <h2 className="resume-title">{data.title}</h2>
              <p className="resume-company">{data.company}</p>
              <p className="resume-location">{data.location}</p>
              <p className="resume-dates">{data.startDate} - {data.endDate}</p>
              <ul className="resume-description">
                {data.description.map((desc, i) => (
                  <li key={i}>{desc}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfessionalResume;
